import React, { useRef } from 'react';
import { Button } from '../ui/button';
import { Textarea } from '../ui/textarea';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '../ui/dialog';
import { AlertTriangle, Camera, Loader2 } from 'lucide-react';
import { getPhotoUrl } from '../../services/api';

/**
 * Dialog for housekeepers to report a problem while completing a task.
 */
const ProblemReportDialog = ({
  open,
  onOpenChange,
  problemText,
  setProblemText,
  problemPhotos,
  onPhotoUpload,
  onSubmit,
  onBack,
  isUploading,
  actionLoading,
  token
}) => {
  const photoInputRef = useRef(null);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <AlertTriangle className="h-5 w-5 text-red-500" />
            Signaler un problème
          </DialogTitle>
        </DialogHeader>
        <div className="py-4 space-y-4">
          <p className="text-sm text-gray-600">
            Décrivez le problème rencontré. La prestation sera validée et l'administrateur sera notifié.
          </p>
          <Textarea 
            placeholder="Décrivez le problème rencontré (dégâts, objets manquants, etc.)..." 
            value={problemText} 
            onChange={(e) => setProblemText(e.target.value)} 
            rows={4} 
            className="resize-none" 
            data-testid="problem-text-input" 
          />
          <div>
            <p className="text-sm text-gray-500 mb-2">Photos du problème (recommandé)</p>
            <div className="flex flex-wrap gap-2">
              {problemPhotos.map((photo, idx) => (
                <div key={`problem-photo-${idx}`} className="w-16 h-16 rounded-lg overflow-hidden bg-gray-100">
                  <img src={getPhotoUrl(photo, token)} alt={`Problem ${idx + 1}`} className="w-full h-full object-cover" />
                </div>
              ))}
              <label className="w-16 h-16 rounded-lg border-2 border-dashed border-gray-300 flex items-center justify-center cursor-pointer hover:bg-gray-50">
                <input 
                  ref={photoInputRef} 
                  type="file" 
                  accept="image/*" 
                  multiple 
                  capture="environment" 
                  className="hidden" 
                  onChange={onPhotoUpload} 
                  disabled={isUploading} 
                />
                {isUploading ? <Loader2 className="h-5 w-5 animate-spin text-gray-400" /> : <Camera className="h-5 w-5 text-gray-400" />}
              </label>
            </div>
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onBack}>Retour</Button>
          <Button 
            className="bg-red-600 hover:bg-red-700" 
            onClick={onSubmit} 
            disabled={actionLoading || !problemText.trim()} 
            data-testid="submit-problem-btn"
          >
            {actionLoading && <Loader2 className="h-4 w-4 animate-spin mr-2" />}
            Valider et signaler
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ProblemReportDialog;
